import { colors, theme } from '@kijiji/theme'
import styled from 'styled-components'

import { Button } from '@/ui/atoms/button'
import { Flex } from '@/ui/atoms/flex'
import { TextLink } from '@/ui/atoms/text-link'

export const ViewButtonStyles = styled(Button)`
  height: ${theme.spacing.husky};
  color: ${colors.grey.primary};
  &:hover,
  &:active {
    background-color: ${colors.purple.light5};
    border-color: ${colors.grey.light3};
    color: ${colors.grey.primary};
  }
`

export const ViewButtonText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  flex-grow: 1;
  font-weight: ${theme.fontWeight.regular};
  font-size: ${theme.spacing.default};
`
export const ViewFlexContainer = styled(Flex)`
  max-width: 100%;
`

export const SrpViewTextLinkButton = styled(TextLink).attrs(() => ({ as: 'button' }))(
  ({ theme }) => `
    align-items: center;
    color: ${colors.purple.primary};
    display: flex;
    font-weight: ${theme.fontWeight.medium};
    gap: ${theme.spacing.mini};
    height: 4rem;
  `
)
